import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
const features = [{
  title: 'Experience Silent Travel',
  description: 'Whisper-Quiet Campervan Journeys',
  image: 'https://cdn.magicpatterns.com/uploads/pKPzBNwMUWtZUzQjDCs91d/6842e88f2f523e985c5fa1a4__DSC8349-2.jpg',
  slug: 'silent-travel'
}, {
  title: 'Air Furniture Technology™',
  description: 'Lighter Campervan Furniture for Smarter Travel',
  image: 'https://cdn.magicpatterns.com/uploads/iSsLTMw4wKgenTWkbWEAxu/_DSC8170.webp',
  slug: 'air-furniture'
}, {
  title: 'Premium Interiors',
  description: 'Hand-crafted luxury with complete upholstery and meticulous attention to detail for unparalleled comfort and style.',
  image: 'https://cdn.magicpatterns.com/uploads/vBzCByw2N7rP6MS6jLeNiZ/_DSC8493.webp',
  slug: 'premium-interiors'
}, {
  title: '16,000 Customization Options',
  description: 'Create a truly personalized campervan with thousands of configuration possibilities to match your unique travel style and preferences.',
  image: 'https://cdn.magicpatterns.com/uploads/7z3is2BCgabuUutCmURgeJ/_DSC8265.webp',
  slug: 'customization'
}, {
  title: 'Signature Craftsmanship',
  description: 'Our unique "one van, one craftsman" philosophy ensures exceptional quality through personal dedication and accountability.',
  image: 'https://cdn.magicpatterns.com/uploads/pPR23bNLSAVudMWhF2ynaG/_DSC8241.webp',
  slug: 'signature-craftsmanship'
}];
export function RobetaDifferenceSection() {
  return <section className="py-28 md:py-36 bg-robeta-mist/20" data-id="element-262">
      <div className="container mx-auto px-6 md:px-12" data-id="element-263">
        <div className="mb-16" data-id="element-264">
          <span className="text-robeta-copper text-xs font-bold uppercase tracking-wide-editorial block mb-4" data-id="element-265">
            The Robeta Difference
          </span>
          <h2 className="text-3xl md:text-4xl font-light text-robeta-black uppercase tracking-editorial max-w-2xl" data-id="element-266">
            Why discerning travelers choose Robeta for their journey.
          </h2>
        </div>

        {/* Row 1: 3 columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4" data-id="element-267">
          {features.slice(0, 3).map((feature, index) => <FeatureCard key={index} feature={feature} index={index} data-id="element-268" />)}
        </div>

        {/* Row 2: 2 columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-269">
          {features.slice(3).map((feature, index) => <FeatureCard key={index + 3} feature={feature} index={index + 3} data-id="element-270" />)}
        </div>
      </div>
    </section>;
}
function FeatureCard({
  feature,
  index
}: {
  feature: (typeof features)[0];
  index: number;
}) {
  return <Link to={`/robeta-difference/${feature.slug}`} data-id="element-271">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6,
      delay: index * 0.1
    }} className="relative aspect-[4/3] overflow-hidden group cursor-pointer" data-id="element-272">
        <img src={feature.image} alt={feature.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-273" />

        {/* Dark gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/10" data-id="element-274" />

        {/* Content */}
        <div className="absolute inset-0 flex flex-col justify-end p-6 md:p-8" data-id="element-275">
          <h3 className="text-robeta-copper text-lg md:text-xl font-medium mb-3 leading-snug" data-id="element-276">
            {feature.title}
          </h3>
          <p className="text-white/90 text-sm font-light leading-relaxed mb-6 max-w-sm" data-id="element-277">
            {feature.description}
          </p>
          <div data-id="element-278">
            <span className="inline-block bg-robeta-black text-white text-[11px] font-bold uppercase tracking-widest px-8 py-3 rounded-full group-hover:bg-robeta-copper transition-colors duration-300" data-id="element-279">
              Read More
            </span>
          </div>
        </div>
      </motion.div>
    </Link>;
}